<div class="center-timeline-controller">
  <div>
    <div id="playbutton">
      @if (!playState()) {
        <i id="playbuttonPlayIcon" class="fa fa-play fa-3x" (click)="PlayPause(true)" title="play"></i>
      }
      @if (playState()) {
        <i id="playbuttonPauseIcon" class="fa fa-pause fa-3x" (click)="PlayPause(false)" title="pause"></i>
      }
      <p id="playbuttonSpeed">{{ formatSpeed(speed) }}</p>
    </div>
  </div>

  <div class="timelineButtons">

    <button id="rewindButton" type="button" class="btn btn-primary timelineButton timelineButtonLeft" title="back to beginning" (click)="goToStart()">
      <i class="fa fa-step-backward"></i>
    </button>

    <button id="rewindButton" type="button" class="btn btn-primary timelineButton timelineButtonLeft" title="slower" (click)="rewind()">
      <i class="fa fa-fast-backward"></i>
    </button>

    <button id="endDateButton" type="button" class="btn btn-primary timelineButton timelineButtonRight" title="jump to end" (click)="goToEnd()">
      <i class="fa fa-step-forward"></i>
    </button>

    <button id="fastForwardButton" type="button" class="btn btn-primary timelineButton timelineButtonRight" title="faster" (click)="fastForward()">
      <i class="fa fa-fast-forward"></i>
    </button>
    <div id="zoomButtonsAndTime" class="dateString">
      <button (click)="zoomOut()" type="button" class="btn btn-primary timeline-zoom-button-left">
        <i class="fa fa-search-minus" aria-hidden="true"></i>
      </button>
      <div id="currentTime">{{ currentDate }}</div>
      <button (click)="zoomIn()" type="button" class="btn btn-primary timeline-zoom-button-right">
        <i class="fa fa-search-plus" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</div>
<div style="border-style: solid;border-color: #404040;"></div>
<div #d3Timeline id="d3Timeline"></div>
<div style="border-style: solid;border-color: #404040;"></div>